import Info from './info/info.js';

function Sobre() {
    return (
        <Info
            title="Sobre o site Domínio Elétrico"
            htmlFileName="./sobre.html"
        />
    );
}

export default Sobre;